"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChainName = exports.ChainId = void 0;
function getEnumKeyByEnumValue(myEnum, enumValue) {
    var keys = Object.keys(myEnum).filter(function (x) { return myEnum[x] === enumValue; });
    return keys.length > 0 ? keys[0] : undefined;
}
var ChainId;
(function (ChainId) {
    ChainId[ChainId["Ethereum"] = 1] = "Ethereum";
    ChainId[ChainId["Ropsten"] = 3] = "Ropsten";
    ChainId[ChainId["Rinkeby"] = 4] = "Rinkeby";
    ChainId[ChainId["Goerli"] = 5] = "Goerli";
    ChainId[ChainId["Kotti"] = 6] = "Kotti";
    ChainId[ChainId["Ethereum Classic"] = 61] = "Ethereum Classic";
    ChainId[ChainId["Mordor"] = 63] = "Mordor";
    ChainId[ChainId["Smart Chain"] = 56] = "Smart Chain";
    ChainId[ChainId["Smart Chain Testnet"] = 97] = "Smart Chain Testnet";
})(ChainId = exports.ChainId || (exports.ChainId = {}));
function getChainName(chainId) {
    return getEnumKeyByEnumValue(ChainId, chainId);
}
exports.getChainName = getChainName;
//# sourceMappingURL=chains.js.map